import { styled } from "@mui/material";

export default styled('img')({});